import {Component, EventEmitter, Input, Output} from '@angular/core';
import {User, UserStatus} from '../../../../../generated/sales-terminal-client';
import {TranslateService} from '@ngx-translate/core';
import {SnackService} from '../../../../../services/snack/snack.service';
import {UtilService} from '../../../../../services/util/util.service';
import {UserService} from '../../../../../services/user/user.service';
import {StatusCode} from '../users-view.component';
import {AuthService} from '../../../../../services/auth/auth.service';
import {TextInputType} from '../../../../../components/forms/text-input/text-input.component';
import {Privileges} from "../../../privileges/privileges.constants";
import {ConfirmDialogComponent} from "../../../../../components/confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-users-view-form',
  templateUrl: './users-view-form.component.html',
  styleUrls: ['./users-view-form.component.scss']
})
export class UsersViewFormComponent {
  @Input() user: User;
  @Input() userStatus: UserStatus;
  @Output() userStatusChange: EventEmitter<UserStatus> = new EventEmitter<UserStatus>();
  @Input() statusCodes: StatusCode[] = [];
  @Input() isView: boolean;
  @Input() isCreate: boolean;
  @Input() isMyProfile: boolean;
  @Output() create: EventEmitter<any> = new EventEmitter<any>();
  @Output() update: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public utilService: UtilService,
    private snackService: SnackService,
    private translateService: TranslateService,
    private authService: AuthService,
    public userService: UserService,
    private dialog: MatDialog) {}

  public get isEdit(): boolean {
    return !this.isView && !this.isCreate;
  }

  public get isClearSessionAllowed() {
    return this.isEdit
      && this.authService.checkPrivileges(Privileges.USER_ADMIN)
      && this.authService.user.isSuperCentre;
  }

  public get heading(): string {
    if (this.isMyProfile) {
      return this.translateService.instant('general.api_my_profile_title');
    } else if (this.isCreate) {
      return this.translateService.instant('general.api_users_form_create_title');
    } else {
      return this.translateService.instant('general.api_users_form_view_title', { user: this.user.firstName + ' ' + this.user.lastName });
    }
  }

  public get canChangeStatusCode(): boolean {
    return !!this.statusCodes.filter(s => !s.disabled).length;
  }

  confirmClearSessions() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '60%',
      panelClass: 'xs-popup',
      data: {
        title: this.translateService.instant('general.api_users_clear_sessions_confirmation_title'),
        description: this.translateService.instant('general.api_users_clear_sessions_confirmation_description')
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.userService.clearSessions(this.user.userId).subscribe(() =>
          this.snackService.showSuccess(this.translateService.instant('general.api_users_refresh_tokens_cleared')));
      }
    });
  }

  public resetPassword(): void {
    this.authService.forgotPassword(this.user.email).subscribe(() =>
      this.snackService.showSuccess(this.translateService.instant('general.api_users_successfully_password_reset_initiated')));
  }

  public resendEmailConfirmation(): void {
    this.userService.resendEmailConfirmation(this.user.userId).subscribe(() =>
      this.snackService.showSuccess(this.translateService.instant('general.api_users_new_email_confirmation_resent')));
  }

  protected readonly TextInputType = TextInputType;
}
